<template>
  <h3 class="content-title">
    <img
      src="https://fmty-picture.oss-cn-hangzhou.aliyuncs.com/ice-icon.jpg"
      height="28"
      class="content-title-icon"
    />
    <span>{{ title }}</span>
  </h3>
</template>

<script>
export default {
  name: "ItemTitle",
  props: {
    title: String,
    needMore: Boolean,
    href: String,
  },
  components: {
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scope>
.content-title {
  color: #E95513;
  display: flex;
  justify-content: center;
  padding: 12px;
  border-bottom: 2px solid #e1d0ba;
}
.content-title-icon{
  margin: 0 10px 0 -15px;
}
</style>
